import getIsMobileDevice from './getIsMobileDevice';

export const IMAGE_MAX_SIZE = 10000000;

export const DESKTOP_APP_WIDTH = 630;
export const MOBILE_APP_WIDTH = 500;
export const APP_WIDTH = getIsMobileDevice() ? MOBILE_APP_WIDTH : DESKTOP_APP_WIDTH;

export const APP_HEIGHT = 900;
